function formatHeader(header) {
    const words = header.split('_');
    
    const formattedHeader = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    return formattedHeader;
}

export {formatHeader}